const toggleItems = document.getElementsByClassName('toggle-item');
const ingredientsToggle = document.getElementById('ingredients-toggle');
const fragrancesToggle = document.getElementById('fragrances-toggle');

Array.from(toggleItems).forEach((element, index) => {
    element.addEventListener('click', function () {
        clearOtherSelected();
        element.classList.add('toggle-item-selected');

        if (element.innerHTML.trim() == 'INGREDIENTES') {
            ingredientsToggle.classList.remove('hidden');
            fragrancesToggle.classList.add('hidden');
        } else {
            fragrancesToggle.classList.remove('hidden');
            ingredientsToggle.classList.add('hidden');
        }
    });
});

function clearOtherSelected() {
    Array.from(toggleItems).forEach((element) =>
        element.classList.remove('toggle-item-selected')
    );
}
